import React, { Component } from 'react';
import axios from "axios";
import {Link} from "react-router-dom";
import moment from "moment";
import formatLink from '../../utils/formatLink';
import css from './ScheduledJobDetails.module.scss';
import Alert from "../../components/Alert/Alert";
import SurveyCalendar from "../SurveyCalendar/SurveyCalendar";
import { fetchS3Photos } from '../../utils/awsHelper';

/**
 * @class
 */
const ScheduledJobDetails = class extends Component {
    // ---------- class fields: ----------
    scheduledId = this.props.match.params.job_id;
    source = axios.CancelToken.source();

    postRequestSchedulable = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "CreatedDate",
            "RecordTypeId",
            "RecordType.Name",
            "Assigned_Crew__c",
            "Assigned_Crew__r.Name",
            "Assigned_Crew__r.Outside_Contractor__c",
            "Assigned_Crew_2__c",
            "Assigned_Crew_2__r.Name",
            "Assigned_Crew_2__r.Outside_Contractor__c",
            "Cancel_Date_Time__c",
            "Cancellation_in_Progress__c",
            "City__c",
            "Codes_Gates_Animals__c",
            "Customer_Name__c",
            "Final_Scheduled_Date__c",
            "Final_Scheduled_Time__c",
            "Financing_Partner__c",
            "Ground_Mount__c",
            "Imging_Job_Created__c",
            "Location__r.Name",
            "Number_of_surveyors_needed__c",
            "Customer_will_be_home__c",
            "Will_the_customer_be_home__c",
            "Permission_to_access_roof__c",
            "Permission_to_access_the_roof__c",
            "Opportunity__c",
            "Opportunity__r.Jurisdiction_opp__c",
            "Opportunity__r.Jurisdiction_opp__r.Field_Notes__c",
            "Opportunity__r.Name",
            "Opportunity__r.Sales_Representative__r.Name",
            "Opportunity__r.Sales_Representative__r.Phone",
            "Opportunity__r.Sales_Representative_2__r.Name",
            "Opportunity__r.Sales_Representative_2__r.Phone",
            "Opportunity__r.Sales_Representative_3__r.Name",
            "Opportunity__r.Sales_Representative_3__r.Phone",
            "Opportunity__r.Active_Post_Proposal__c",
            "Opportunity__r.Active_Post_Proposal__r.PCS_Conductor_Limit_A__c",
            "Opportunity__r.Active_Site_Assessment__c",
            "Opportunity__r.Active_Site_Assessment__r.Export_Limit__c",
            "Primary_Phone__c",
            "Scheduled__c",
            "Secondary_Phone__c",
            "Shade_Data_Method__c",
            "Site_Survey_Completed__c",
            "Site_Survey_Date__c",
            "Site_Survey_Notes__c",
            "Site_Survey_Scheduled_Start__c",
            "Site_Survey_Scheduled_End__c",
            "SS_Time_Placeholder__c",
            "Schedulable_Complete__c",
            "Schedulable_Notes__c",
            "Schedulable_Event__r.Name",
            "Scheduled_Date__c",
            "Start_Time_24h__c",
            "State__c",
            "Street__c",
            "Structure_Levels__c",
            "Survey_Start_Time__c",
            "Surveyor_Notes__c",
            "System_Size__c",
            "Time_Slot__c",
            "Time_Window__c",
            "Type__c",
            "Unschedule_Details__c",
            "Survey_Completed_By__c",
            "Survey_Completed_By__r.Name",
            "Second_surveyor__c",
            "Survey_Additions__c",
            "Zip__c",
            "Inspection_Outcome__c",
            "Jobsite_Photos__c",
            "Field_Notes__c",
            "Headed_to_Job__c",
            "X4_high_array__c",
            "X5_high_array__c",
            "Survey_Type__c",
            "Is_the_customer_requesting_an_attic_run__c",
            "RSS__c",
            "Electrical_Type__c",
            "Electrical_Sub_Type__c",
            "Number_of_days__c",
            "Install_Field_Team__c",
            "Assigned_Crew__r.Field_Team__c",
            "Is_this_a_RSS__c"
        ],
        "where": {
            "Id": this.scheduledId
        }
    };
    postRequestFieldJob = {
        limit: 1,
        skip: 0,
        fields: [
            "Id"
        ],
        where: {
            Schedulable__c: this.scheduledId
        }
    };

    // ---------- state: ----------
    state = {
        fieldJobId: '',
        scheduledDetail: {},
        salesReps: [],
        shouldDisableStartButton: false,  // set to true when user clicks 'start job' -- this is to prevent user from clicking the button multiple times and creating multiple records

        // IMGING
        imgingCreated: '',
        disableImging: '',
        shouldShowAlert: false,
        alertMessage: 'IMGING Job Created.',

        disableHeadedToJob:'',

        jurNotes: '',
        shouldShowCalendar: false,

        designPermitDocs: [],

        fieldTeam: []
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        axios.post(
            '/sf/fieldjob/findNo',
            this.postRequestFieldJob,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // since field job id doesn't affect rendering, we can avoid using state:
                if (res.data.records[0]) {
                    this.setState({
                        fieldJobId: res.data.records[0].Id
                    });
                }

            })
            .catch(err => console.log('POST Error:\n', err));

        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSchedulable,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // the post request is limited by 1 (since we only want a single record), we get the first item in records array:
                const data = res.data.records[0];

                // for convenience, add `FullAddress` prop:
                data.FullAddress = `${data.Street__c}, ${data.City__c}, ${data.State__c}  ${data.Zip__c}`;

                // extract sales reps for easier iteration:
                const salesReps = [];
                if (data.Opportunity__r.Sales_Representative__r) {
                    salesReps.push(data.Opportunity__r.Sales_Representative__r);
                }
                if (data.Opportunity__r.Sales_Representative_2__r) {
                    salesReps.push(data.Opportunity__r.Sales_Representative_2__r);
                }
                if (data.Opportunity__r.Sales_Representative_3__r) {
                    salesReps.push(data.Opportunity__r.Sales_Representative_3__r);
                }

                let imgingCreated;
                if (data.IMGING_Job_Created__c !== null) {
                    imgingCreated = true;
                }

                let disableHeadedToJob;
                if (data.Headed_to_Job__c !== null) {
                    disableHeadedToJob = true;
                }

                let notes = '';
                if(data.Opportunity__r.Jurisdiction_opp__c !== null){
                    if(data.Opportunity__r.Jurisdiction_opp__r.Field_Notes__c !== null){
                        notes = data.Opportunity__r.Jurisdiction_opp__r.Field_Notes__c;
                    }
                } else {
                    notes = '';
                }

                let surveyTypeClean = '';
                if(data.Survey_Type__c !== null){
                    surveyTypeClean = data.Survey_Type__c.replaceAll(';', ', ')
                }

                if(data.Assigned_Crew__c !== null && data.Assigned_Crew__r.Field_Team__c) {
                    let activeFieldPayload = {
                        limit: 10,
                        fields: {
                            Id: 1,
                            Name: 1,
                            Field_Team__c: 1
                        },
                        where: {
                            Active__c: true,
                            Field_Team__c: data.Assigned_Crew__r.Field_Team__c
                        },
                        orderBy: {
                            Name: 1
                        }
                    };

                    axios.post(
                        '/sf/contact/findNo',
                        activeFieldPayload,
                        {
                            cancelToken: this.source.token
                        })
                        .then((res) => {
                            const data = res.data.records;

                            if(data.length !== 0){
                                let tempList = [];
                                data.forEach(tech => {
                                    tempList.push(tech.Name);
                                });

                                this.setState({fieldTeam: tempList});
                            }
                        })
                        .catch(err => console.log('(GET) Error tyring to fetch field team members: ', err));
                }

                this.setState({
                    scheduledDetail: data,
                    salesReps,
                    imgingCreated,
                    disableHeadedToJob,
                    jurNotes: notes,
                    surveyType: surveyTypeClean
                });

                // this.configureAWS();
                this.getDocs();
            })
            .catch(err => console.log('POST Error:\n', err));
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ----------  methods: ----------
    getDocs = async() => {
        const keys = {};
        fetchS3Photos({
            recordId: this.state.scheduledDetail.Opportunity__c,
            type: '006-opportunity',
            existingState: keys,
            source: this.source,
            process: 'getRepUploads'
        })
        .then(returnedFiles => {
            let docs = [];
            
            Object.keys(returnedFiles).map(doc =>{
                if(returnedFiles[doc] === 'Design Plans' || returnedFiles[doc] === 'Permit'){
                    const parts = doc.split('/');
                    const docName = parts[parts.length - 1];
                    docs.push({name: docName, key: 'https://v3-salesforce-file-storage.s3.us-west-2.amazonaws.com/' + doc});
                }
            })

            this.setState({designPermitDocs: docs});
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });
    }

    /**
     * Handler for when user starts a new field job.
     * Creates the records for the new fieldjob, marks it as started, and redirects to the created fieldjob form page.
     */
    jobStartOnClick = () => {
        const postRequestRecordType = {
            "limit": 300,
            "skip": 0,
            "fields": [
                "Id",
                "SobjectType",
                "Name",
                "IsActive"
            ],
            "where": {
                "IsActive": true,
                "SobjectType": "Field_Job__c",
                "Name": this.state.scheduledDetail['RecordType']['Name']
            }
        };

        // disable the 'start job' button -- this prevents the user from clicking the button multiple times and creating multiple records:
        this.setState({ shouldDisableStartButton: true });

        // get records:
        axios.post(
            '/sf/recordtype/findNo',
            postRequestRecordType,
            {
                cancelToken: this.source.token
            })
            .then((resRecordType) => {
                // get last name of opportunity:
                let lastName = this.state.scheduledDetail['Opportunity__r']['Name'].split(" ");
                lastName = lastName[lastName.length - 1];

                const postRequestNewJob = {
                    RecordTypeId:       resRecordType.data.records[0].Id,
                    Schedulable__c:     this.scheduledId,
                    Job_Date__c:        moment().format('YYYY-MM-DDT00:00:00Z'),
                    Status__c:          'In Progress',
                    Name:               `${this.state.scheduledDetail.Type__c}: ${lastName} ${moment().format('YYYY-MM-DD')}`,
                    Clocked_Start__c:   moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                    Job_Subtype__c:     this.state.scheduledDetail['Schedulable_Event__r']['Name'].includes('Partial') ? 'Partial' : 'Standard'
                };

                axios.post(
                    '/sf/fieldjob/create',
                    postRequestNewJob,
                    {
                        cancelToken: this.source.token
                    })
                    .then((resFieldJob) => {
                        axios.put(
                            '/sf/schedulable/update',
                            {
                                Id: this.scheduledId,
                                Field_Job__c: resFieldJob.data.id,
                            },
                            {
                                cancelToken: this.source.token
                            })
                            .then(() => {
                                // redirect to the newly created field job:

                                // if(resFieldJob.data.id && (this.state.scheduledDetail.Type__c !== 'Site Survey' && this.state.scheduledDetail.Type__c !== 'Inspection' && this.state.scheduledDetail.Type__c !== 'Install')) {
                                //     this.props.history.push(`/fieldList/${resFieldJob.data.id}`);
                                // } else {
                                //     this.props.history.push(`/fieldJob/${resFieldJob.data.id}`);
                                // }

                                this.props.history.push(`/fieldJob/${resFieldJob.data.id}`)
                                // TODO: probably want to add an alert message to the user if any of these API calls (.catch() statements) fail:
                            })
                            .catch(err => console.log('POST Error:\n', err));
                    })
                    .catch(err => console.log('POST Error:\n', err));
            })
            .catch(err => console.log('POST Error:\n', err));
    };

    createIMGING = () => {
        this.setState({disableImging: true});
        axios.put(
            '/sf/schedulable/update',
            {
                Id: this.scheduledId,
                IMGING_Job_Created__c: moment().format('YYYY-MM-DDTHH:mm:ssZ')
            })
        .then(() => {
            console.log('IMGING Job Created');
            this.setState({
                imgingCreated: true,
                shouldShowAlert: true
            });
            setTimeout(() => {
                this.setState({ shouldShowAlert: false })
            }, 5500);
        })
        .catch(err => {
            console.log('PUT Error:\n', err);
            this.setState({disableImging: false})
        });
    };

    headedToJob = () => {
        this.setState({disableHeadedToJob: true});
        axios.put(
            '/sf/schedulable/update',
            {
                Id: this.scheduledId,
                Headed_to_Job__c: moment().format('YYYY-MM-DDTHH:mm:ssZ')
            })
        .then(() => {
            console.log('Headed To Job');
            this.setState({
                shouldShowAlert: true
            });
            setTimeout(() => {
                this.setState({ shouldShowAlert: false })
            }, 5500);
        })
        .catch(err => {
            console.log('PUT Error:\n', err);
            this.setState({disableHeadedToJob: false})
        });
    };

    handleShouldShowCalendar = (val) => {
        this.setState({shouldShowCalendar: val});
    };

    render() {
        return (
            <div>
            {
                this.state.shouldShowCalendar ? 
                <SurveyCalendar onShouldShowCalendar={(val) => this.handleShouldShowCalendar(val)} oppId={this.state.scheduledDetail.Opportunity__c} resurvey={true}/> 
                : 
                <div className={css.ScheduledJobDetails}>
                    <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage}</Alert>

                    <h1 className="my-0">
                        <a
                            className="text-white"
                            href={`https://v3electric.my.site.com/frontendOps/s/detail/${this.state.scheduledDetail.Opportunity__c}`}
                        >{this.state.scheduledDetail.Name}</a>
                    </h1>
                    <h2 className="my-0">{this.state.scheduledDetail.Type__c}</h2>
                    <div className={this.state.scheduledDetail.Ground_Mount__c ? 'row mt-3' : 'd-none'}>
                        <h2 className="col-12 text-white">Ground mount</h2>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 col-sm-6">
                            <div>
                                <a
                                    className="text-primary font-weight-bold"
                                    href={`https://www.google.com/maps/search/?api=1&query=${this.state.scheduledDetail.FullAddress}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{this.state.scheduledDetail.FullAddress}</a>
                            </div>
                            <h4 className="mt-1">Full Address</h4>
                        </div>

                        {/* ----- phone: ----- */}
                        <div className="col-12 col-sm-6">
                            <div className={this.state.scheduledDetail.Secondary_Phone__c ? '' : 'd-none'}>
                                <div>
                                    <a className="text-primary font-weight-bold" href={`tel:${this.state.scheduledDetail.Secondary_Phone__c}`}>{this.state.scheduledDetail.Secondary_Phone__c}</a>
                                </div>
                                <h4 className="mt-1">Phone</h4>
                            </div>
                            <div className={this.state.scheduledDetail.Primary_Phone__c ? 'mt-3' : 'd-none'}>
                                <div>
                                    <a className="text-primary font-weight-bold" href={`tel:${this.state.scheduledDetail.Primary_Phone__c}`}>{this.state.scheduledDetail.Primary_Phone__c}</a>
                                    <h4 className="mt-1">Secondary Phone</h4>
                                </div>
                            </div>
                            <div className={(!this.state.scheduledDetail.Secondary_Phone__c && !this.state.scheduledDetail.Primary_Phone__c) ? 'mt-3' : 'd-none'}>
                                <div className="text-danger">NO PHONE NUMBER</div>
                                <h4 className="mt-1">Phone</h4>
                            </div>
                        </div>{/* /phone */}
                    </div>

                    {/* ---------- Details Table: ---------- */}
                    <div className="mt-5">
                        <h2>Details</h2>
                        {/* ----- if site surveys: ----- */}
                        <table className={this.state.scheduledDetail.Type__c === 'Site Survey' ? css.ScheduledJobDetails__Table : 'd-none'}>
                            <tbody>
                            <tr>
                                <td>Site Survey Date</td>
                                <td className="font-weight-bold">{moment(this.state.scheduledDetail.Site_Survey_Date__c).format('MM/D/YY')}</td>
                            </tr>
                            <tr>
                                <td>Survey Time Slot</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Time_Slot__c}</td>
                            </tr>
                            <tr>
                                <td>Survey Type</td>
                                <td className="font-weight-bold">{this.state.surveyType}</td>
                            </tr>
                            <tr>
                                <td>Structure Levels</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Structure_Levels__c}</td>
                            </tr>
                            <tr>
                                <td>Ground Mount</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Ground_Mount__c ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <td>Attic Run</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Is_the_customer_requesting_an_attic_run__c ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <td>Codes, Gates, Animals</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Codes_Gates_Animals__c}</td>
                            </tr>
                            <tr>
                                <td>{this.state.scheduledDetail.Type__c} Notes</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Site_Survey_Notes__c}</td>
                            </tr>
                            <tr>
                                <td>Is this a RSS?</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Is_this_a_RSS__c ? 'Yes' : 'No'}</td>
                            </tr>
                            {
                                this.state.scheduledDetail.Is_this_a_RSS__c === true ?
                                <tr>
                                    <td>RSS Reason(s)</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.RSS__c}</td>
                                </tr>
                                :
                                ''
                            }
                            <tr>
                                <td>Will the Customer be Home?</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Will_the_customer_be_home__c}</td>
                            </tr>
                            <tr>
                                <td>Permission to access roof if not home?</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Permission_to_access_the_roof__c}</td>
                            </tr>
                            <tr>
                                <td>Surveyors Needed</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Number_of_surveyors_needed__c}</td>
                            </tr>
                            <tr>
                                <td>Completed By</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.Survey_Completed_By__c ? this.state.scheduledDetail.Survey_Completed_By__r.Name : "---"}</td>
                            </tr>
                            <tr>
                                <td>Job Photos Link</td>
                                <td className="font-weight-bold">
                                    <span className={this.state.scheduledDetail.Jobsite_Photos__c ? '' : 'd-none'}>
                                        <a href={formatLink(this.state.scheduledDetail.Jobsite_Photos__c)} target="_blank" rel="noopener noreferrer">{this.state.scheduledDetail.Jobsite_Photos__c}</a>
                                    </span>
                                    <span className={this.state.scheduledDetail.Jobsite_Photos__c ? 'd-none' : ''}>LINK MISSING</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        {/* ----- if NOT site surveys: ----- */}
                        <table className={
                            this.state.scheduledDetail.Type__c &&
                            this.state.scheduledDetail.Type__c !== 'Site Survey'
                                ?
                                css.ScheduledJobDetails__Table
                                :
                                'd-none'
                        }>
                            <tbody>
                                <tr>
                                    <td>{this.state.scheduledDetail.Type__c} Date</td>
                                    <td className="font-weight-bold">{moment(this.state.scheduledDetail.Scheduled_Date__c).format('MM/D/YY')}</td>
                                </tr>
                                {
                                    this.state.scheduledDetail.Type__c === 'Install' ?
                                    <>
                                    <tr>
                                        <td>Number of Days</td>
                                        <td className="font-weight-bold">{this.state.scheduledDetail.Number_of_days__c}</td>
                                    </tr>
                                    <tr>
                                        <td>MSP Export Limit</td>
                                        <td className="font-weight-bold">{this.state.scheduledDetail.Opportunity__r.Active_Post_Proposal__c && this.state.scheduledDetail.Opportunity__r.Active_Post_Proposal__r.PCS_Conductor_Limit_A__c ? this.state.scheduledDetail.Opportunity__r.Active_Post_Proposal__r.PCS_Conductor_Limit_A__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td>Site Export Limit</td>
                                        <td className="font-weight-bold">{this.state.scheduledDetail.Opportunity__r.Active_Site_Assessment__c && this.state.scheduledDetail.Opportunity__r.Active_Site_Assessment__r.Export_Limit__c ? this.state.scheduledDetail.Opportunity__r.Active_Site_Assessment__r.Export_Limit__c : "---"}</td>
                                    </tr>
                                    </>
                                    :
                                    null
                                }
                                <tr>
                                    <td>Time Slot</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.Time_Window__c}</td>
                                </tr>
                                {
                                    this.state.scheduledDetail.Electrical_Type__c ?
                                        <tr>
                                            <td>Electrical Type</td>
                                            <td className="font-weight-bold">{this.state.scheduledDetail.Electrical_Type__c ? this.state.scheduledDetail.Electrical_Type__c : "---"}</td>
                                        </tr>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduledDetail.Electrical_Sub_Type__c ?
                                        <tr>
                                            <td>Electrical Sub Type</td>
                                            <td className="font-weight-bold">{this.state.scheduledDetail.Electrical_Sub_Type__c ? this.state.scheduledDetail.Electrical_Sub_Type__c : "---"}</td>
                                        </tr>
                                        :
                                        null
                                }
                                {/* <tr>
                                    <td>Ground Mount</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.Ground_Mount__c ? "Yes" : "No"}</td>
                                </tr> */}
                                <tr>
                                    <td>CU Preferences/Access Info</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.Codes_Gates_Animals__c}</td>
                                </tr>
                                {/* <tr>
                                    <td>AHJ Confirmed</td>
                                    <td className="font-weight-bold">{moment(this.state.scheduledDetail.AHJ_Confirmed__c).format('MM/D/YY')}</td>
                                </tr> */}
                                <tr>
                                    <td>Customer Confirmed</td>
                                    <td className="font-weight-bold">{moment(this.state.scheduledDetail.Customer_Confirmed__c).format('MM/D/YY')}</td>
                                </tr>
                                <tr>
                                    <td>Field Notes</td>
                                    <td className="font-weight-bold"><textarea rows="8" value={this.state.scheduledDetail.Schedulable_Notes__c}/></td>
                                </tr>
                                <tr>
                                    <td>{this.state.scheduledDetail.Type__c} Completed</td>
                                    <td className="font-weight-bold">
                                        {this.state.scheduledDetail.Schedulable_Complete__c ? moment(this.state.scheduledDetail.Schedulable_Complete__c).format('MM/D/YY') : "---"}
                                    </td>
                                </tr>
                                {
                                    // we use a ternary expression rather than hiding/showing via CSS classes because the table bg color alters by even/odd row,
                                    // so a hidden table row will give us 2 adjacent rows with the same bg color:
                                    this.state.scheduledDetail.Type__c === 'Inspection' ?
                                        <tr>
                                            <td>{this.state.scheduledDetail.Type__c} Outcome</td>
                                            <td className="font-weight-bold">{this.state.scheduledDetail.Inspection_Outcome__c ? this.state.scheduledDetail.Inspection_Outcome__c : "---"}</td>
                                        </tr>
                                        :
                                        null
                                }
                                {/* <tr>
                                    <td>Completed By</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.Assigned_Crew__c ? this.state.scheduledDetail.Assigned_Crew__r.Name : "---"}</td>
                                </tr>
                                <tr>
                                    <td>Crew Notes</td>
                                    <td className="font-weight-bold">{this.state.scheduledDetail.Completion_Notes__c}</td>
                                </tr> */}
                                <tr>
                                    <td>Job Photos Link</td>
                                    <td className="font-weight-bold">
                                        <span className={this.state.scheduledDetail.Jobsite_Photos__c ? '' : 'd-none'}>
                                            <a href={formatLink(this.state.scheduledDetail.Jobsite_Photos__c)} target="_blank" rel="noopener noreferrer">{this.state.scheduledDetail.Jobsite_Photos__c}</a>
                                        </span>
                                        <span className={this.state.scheduledDetail.Jobsite_Photos__c ? 'd-none' : ''}>LINK MISSING</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Jurisdiction Notes</td>
                                    <td className="font-weight-bold">{this.state.jurNotes}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* ---------- GM Arrays Table: ---------- */}
                    <div className={this.state.scheduledDetail.Type__c === 'Site Survey' ? "mt-5": 'd-none'}>
                        <h2>GM Array Sizes</h2>
                        <table className={css.ScheduledJobDetails__Table}>
                            <tbody>
                            {/* <tr>
                                <td>If a 4-high doesn't fit we can do 5-high with added engineering costs, always default to a 4-high array.</td>
                                <td></td>
                            </tr> */}
                            <tr>
                                <td>4-High Array</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.X4_high_array__c ? this.state.scheduledDetail.X4_high_array__c : "---"}</td>
                            </tr>
                            {/* <tr>
                                <td>5-High Array</td>
                                <td className="font-weight-bold">{this.state.scheduledDetail.X5_high_array__c ? this.state.scheduledDetail.X5_high_array__c : "---"}</td>
                            </tr> */}
                            </tbody>
                        </table>
                    </div>

                    {/* ---------- Sales Reps Table: ---------- */}
                    <div className={
                        (
                            (!this.state.scheduledDetail.Assigned_Crew__r || this.state.scheduledDetail.Assigned_Crew__r.Outside_Contractor__c !== true) &&
                            (!this.state.scheduledDetail.Assigned_Crew_2__r || this.state.scheduledDetail.Assigned_Crew_2__r.Outside_Contractor__c !== true)
                        )
                            ?
                            'mt-5'
                            :
                            'd-none'
                    }>
                        <h2>Sales Representatives</h2>
                        <table>
                            <tbody>
                            {
                                this.state.salesReps.map((rep, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{rep.Name}</td>
                                            <td className="font-weight-bold">
                                                <span className={rep.Phone ? '' : 'd-none'}>
                                                    <a href={`tel:${rep.Phone}`}>{rep.Phone}</a>
                                                </span>
                                                <span className={rep.Phone ? 'd-none' : ''}>NO PHONE NUMBER</span>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={this.state.scheduledDetail.Type__c === 'Install' || this.state.scheduledDetail.Type__c === 'Electrical' ? 'mt-5' : 'd-none'}>
                        <h2>Field Team</h2>
                        <table>
                            <tbody>
                            {
                                this.state.fieldTeam.map((tech, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{tech}</td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={this.state.designPermitDocs.length !== 0  ? 'mt-5' : 'd-none'}>
                        <h2>Design Plans & Permits</h2>
                        <table>
                            <tbody>
                            {
                                this.state.designPermitDocs.map((doc, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{doc.name}</td>
                                            <td className="font-weight-bold">
                                                <a href={doc.key} target="_blank">Link To Doc</a>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    {/* ---------- Start/Edit Job: ---------- */}
                    {/* prevent user button click until data has been fetched: */}
                    <div className={this.state.scheduledDetail.Name || this.state.scheduledDetail.Type__c ? 'mt-5' : 'd-none'}>
                        {/* if `fieldJobId` is set, then the job has already been started:  */}
                        <div className={this.state.fieldJobId ? '' : 'd-none'}> 
                            <Link to={`/fieldJob/${this.state.fieldJobId}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Edit Job</button>
                            </Link>
                        </div>

                        <div className={this.state.fieldJobId ? 'd-none' : ''}>
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.jobStartOnClick()} disabled={this.state.shouldDisableStartButton}>Start Job</button>
                        </div>
                    </div>

                    {/* ---------- Photo Pack: ---------- */}
                    <div className={this.state.scheduledDetail.Type__c === 'Install' ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/install/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Install Photo Pack</button>
                            </Link>
                        </div>
                        <div className='mt-3'>
                            <Link to={`/photoPack/electrical/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Solar Electrical Photo Pack</button>
                            </Link>
                        </div>
                        <div className='mt-3'>
                            <Link to={`/photoPack/battery/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Battery Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.scheduledDetail.Type__c === 'Electrical' ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/mpu/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">MPU Photo Pack</button>
                            </Link>
                        </div>
                        <div className='mt-3'>
                            <Link to={`/photoPack/battery/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Battery Photo Pack</button>
                            </Link>
                        </div>
                        <div className='mt-3'>
                            <Link to={`/photoPack/miscElectrical/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Misc Electrical Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.scheduledDetail.Type__c === 'Service Call' ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/serviceCall/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Service Call Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.scheduledDetail.Type__c === 'Inspection' ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/inspection/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Inspection Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.scheduledDetail.Type__c === 'Site Survey' ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/siteSurvey/${this.state.scheduledDetail.Id}/${this.state.scheduledDetail.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Survey Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    {/* ---------- Create IMGING Job: ---------- */}
                    {/* ---------- for Site Surveys ---------- */}
                    <div className="mt-3">
                        {   this.state.scheduledDetail.Type__c === 'Site Survey' && !this.state.imgingCreated ?
                            <button className="btn btn-primary w-100 text-md" type="button" disabled={this.state.disableImging} onClick={() => this.createIMGING()}>Create IMGING Job</button>
                            :
                            null
                        }
                    </div>

                    {/* ---------- Headed To Job: ---------- */}
                    <div className="mt-3">
                        {   this.state.scheduledDetail.Type__c === 'Install' || this.state.scheduledDetail.Type__c === 'Electrical' ?
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.headedToJob()} disabled={this.state.disableHeadedToJob}>Headed To Job</button>
                            :
                            null
                        }
                    </div>

                    {/* ---------- Scope of Work: ---------- */}
                    <div className="mt-3">
                        <a href={`https://v3electric.my.salesforce-sites.com/ScopeOfWork?id=${this.state.scheduledDetail.Opportunity__c}`}>
                            <button className="btn btn-primary w-100 text-md" type="button">Scope of Work</button>
                        </a>
                    </div>

                    {/* ---------- Existing Photos: ---------- */}
                    <div className="mt-3">
                        <Link to={`/existingPhotos/${this.state.scheduledDetail.Opportunity__c}`}>
                            <button className="btn btn-primary w-100 text-md" type="button">Existing Photos</button>
                        </Link>
                    </div>

                    {/* ---------- Reschedule Site Survey: ---------- */}
                    {   this.state.scheduledDetail.Type__c === 'Site Survey' ?
                        <div className="mt-3">
                                <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.setState({shouldShowCalendar: true})}>Reschedule Site Survey</button>
                        </div>
                        :
                        ''
                    }

                </div>
            }
            </div>
        );
    }
};

export default ScheduledJobDetails;
